module.exports = __webpack_public_path__ + "img/logo-2.f3d8afbb.png";